"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = TrialExpired;
var react_1 = __importDefault(require("react"));
var text_1 = __importDefault(require("web/components/primitives/text"));
var primitives_1 = require("web/components/primitives");
var colors_1 = __importDefault(require("shared/constants/colors"));
var login_image_jpg_1 = __importDefault(require("assets/images/global/login-image.jpg"));
var image_util_1 = require("web/utils/image.util");
var style_scss_1 = __importDefault(require("./style.scss"));
var cachedImage = null;
function TrialExpired() {
    var _a = react_1.default.useState(cachedImage), loadedImg = _a[0], setLoadedImg = _a[1];
    react_1.default.useEffect(function () {
        (0, image_util_1.getBase64FromImageUrl)(login_image_jpg_1.default).then(function (img) {
            setLoadedImg(img);
            cachedImage = img;
        });
    }, [setLoadedImg]);
    if (!loadedImg) {
        return null;
    }
    return (react_1.default.createElement(primitives_1.FlexContainer, { flexDirection: "column", className: style_scss_1.default.layout },
        react_1.default.createElement(primitives_1.FlexContainer, { className: style_scss_1.default.container },
            react_1.default.createElement("div", { className: style_scss_1.default.scrollable },
                react_1.default.createElement(primitives_1.FlexContainer, { className: style_scss_1.default.formContainer, flexDirection: "column", justifyContent: "spaceBetween" },
                    react_1.default.createElement(primitives_1.FlexContainer, { flexDirection: "column" },
                        react_1.default.createElement(text_1.default, { size: "66", variant: "h1", bold: true, style: { color: colors_1.default.navy } }, "Trial Ended"),
                        react_1.default.createElement(text_1.default, { size: "36", variant: "h2", style: {
                                color: colors_1.default.deep_gray,
                                marginTop: '16px',
                                fontWeight: 700,
                            } },
                            "To keep using the app and access all features,",
                            react_1.default.createElement("br", null),
                            " please subscribe to a plan.")),
                    react_1.default.createElement(primitives_1.FlexContainer, { style: { alignSelf: 'self-end', marginTop: '5rem' } },
                        react_1.default.createElement("a", { href: "https://lifeloop.com/contact-us", target: "_blank", rel: "noreferrer" },
                            react_1.default.createElement(primitives_1.Button, { type: "required" }, "Get in Touch"))))),
            react_1.default.createElement("div", { className: style_scss_1.default.imageContainer },
                react_1.default.createElement("img", { src: loadedImg, alt: "LifeLoop Public", className: style_scss_1.default.image })))));
}
